// extracted by mini-css-extract-plugin
module.exports = {"container":"admin-fee_container__PaWSz","button":"admin-fee_button__0Plfv","drawerContainer":"admin-fee_drawerContainer__pH_F2","drawerText":"admin-fee_drawerText__Gm_Wh"};